import React, {Component} from 'react'
import OrdersReportPage from './OrdersReportPage'

class OrdersReportContainer extends Component {

    render() {

        return (
            <div className="OrdersReportContainer">
                <OrdersReportPage/>
            </div>
        )
    }
}

export default OrdersReportContainer